<template>
  <div>
    <v-form>
      <v-progress-linear
        :indeterminate="true"
        v-if="loading"
      ></v-progress-linear>
      <v-card-title>
        <span class="title">
          <v-icon class="hidden-xs-only">attach_money</v-icon>
          {{ $tc("income", 2) }} / {{ $tc("deduction", 2) }}
        </span>

        <v-spacer></v-spacer>

        <v-row row wrap>
          <v-col xs="4" class="text-xs-center">
            <v-select
              :label="$t('year')"
              v-model="year"
              v-bind:items="years"
              @change="onChangeYear"
            ></v-select>
          </v-col>

          <v-col xs="4" class="text-xs-center">
            <v-select
              :label="$t('from')"
              v-model="monthFrom"
              v-bind:items="months"
              @change="onChangeFrom"
            ></v-select>
          </v-col>

          <v-col xs="4" class="text-xs-center">
            <v-select
              :label="$t('to')"
              v-model="monthTo"
              v-bind:items="months"
              @change="onChangeTo"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-title>

      <div class="center-full" v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        hide-default-footer
        v-if="!loading"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:item.conceptIncidentDate="{ item }">
          <v-row>
            <v-col>{{ item.conceptIncidentDate | formatToDate }}</v-col>
          </v-row>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.conceptIncidentValue="{ item }">
          <v-row>
            <v-col>{{ item.conceptIncidentValue | formatToCurrency }}</v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-form>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          fixed
          dark
          fab
          bottom
          right
          color="accent"
          @click="get()"
          v-on="on"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
      <span>Refrescar</span>
    </v-tooltip>
  </div>
</template>

<script>
import { i18n } from "@/i18n";
import { responseException } from "@/assets/js/common";
import { months } from "@/assets/js/data/months";
import { years } from "@/assets/js/data/years";

export default {
  data() {
    return {
      loading: false,
      years: years,
      year: new Date().getFullYear(),
      months: months,
      monthFrom: new Date().getMonth() + 1,
      monthTo: new Date().getMonth() + 1,
      headers: [
        {
          text: i18n.t("date"),
          value: "conceptIncidentDate",
        },
        {
          text: i18n.t("concept"),
          value: "conceptName",
        },
        {
          text: i18n.t("value"),
          value: "conceptIncidentValue",
          align: "right"
        },
      ],
      items: [],
    };
  },
  methods: {
    get: function() {
      this.loading = true;
      this.$http
        .get(
          `hrm/concept-incidents?year=${this.year}&monthFrom=${this.monthFrom}&monthTo=${this.monthTo}&hours=false`
        )
        .then(
          (response) => {
            this.items = response.body;
            this.loading = false;
          },
          (response) => {
            this.$swal({
              icon: 'error',
              title: this.$t('errorOcurred'),
              text: responseException(response)
            })
            this.loading = false;
          }
        );
    },
    onChangeYear: function(year) {
      this.year = year;
      this.get();
    },
    onChangeFrom: function(monthFrom) {
      this.monthFrom = monthFrom;
      this.get();
    },
    onChangeTo: function(monthTo) {
      this.monthTo = monthTo;
      this.get();
    },
  },
  mounted: function() {
    this.get();
  },
};
</script>
